import { initOffersAccordion } from './accardion.js';
import { initAccountModal } from './accountModal.js';
import { initCarConfigurator } from './carConfigurator.js';
import { initCardsSlider } from './cardsSlider.js';
import { initGalleryModal } from './galleryModal.js';
import { initGallerySlider } from './gallerySlider.js';
import { initHeaderMenu } from './headerMenu.js';
import { initHeaderMenuMob } from './headerMenuMobile.js';
import { initNewsSlider } from './newsSlider.js';
import { initSafetySlider } from './safetySlider.js';
import { initSidebarMenu } from './sidebarMenu.js';
import { sliderCategory } from './sliderCategory.js';
import { initSliderHeader } from './sliderHeader.js';
import { initModelStickyDropdown } from './stickyDropdown.js';
import { initStickyNav } from './stickyNav.js';
import initOfferSection from './tabSwitch.js';

document.addEventListener('DOMContentLoaded', () => {
  try {
    initSliderHeader?.();
    initOfferSection?.();
    initHeaderMenu?.();
    initCardsSlider?.();
    initCarConfigurator?.();
    sliderCategory?.();
    initSidebarMenu?.();
    initStickyNav?.();
    initAccountModal?.();
    initGalleryModal?.();
    initHeaderMenuMob?.();
    initOffersAccordion?.();
    initModelStickyDropdown?.();
    initNewsSlider?.();
    initSafetySlider?.();
    initGallerySlider?.();
  } 
  catch (err) {
    console.error('[main.js] init error:', err);
  }
});